import { Card, Classes, Colors, H1 } from "@blueprintjs/core";
import React from "react";

const  checkData =  total => {
  if(parseInt(total) === 0){
    return 0
  }
  if(parseInt(total)){
    return parseInt(total)
  } else {
    return 'Kosong'
  }
}




export default function SCard({ total, text, loading, secondaryColor }) {
  const whatColor = (color = "default") => {
    if (color === "pelaksana") {
      return {
        backgroundColor: Colors.GOLD4,
        color: Colors.DARK_GRAY5,
        height: "100%",
      };
    } else if (color === "fungsional") {
      return {
        backgroundColor: Colors.GRAY1,
        color: Colors.WHITE,
        height: "100%",
      };
    } else if (color === "struktural") {
      return {
        backgroundColor: Colors.ROSE4,
        color: Colors.WHITE,
        height: "100%",
      };
    } else if (color === "DisabilitasFisik") {
      return {
        backgroundColor: Colors.BLUE4,
        color: Colors.DARK_GRAY5,
        height: "100%",
      };
    } else if (color === "DisabilitasMental") {
      return {
        backgroundColor: Colors.GREEN3,
        color: Colors.DARK_GRAY5,
        height: "100%",
      };
    } else if (color === "DisabilitasIntelek") {
      return {
        backgroundColor: Colors.ORANGE2,
        color: Colors.DARK_GRAY5,
        height: "100%",
      };
    } else if (color === "DisabilitasSensorik") {
      return {
        backgroundColor: Colors.VERMILION2,
        color: Colors.WHITE,
        height: "100%",
      };
    } else if (color === "DisabilitasGanda") {
      return {
        backgroundColor: Colors.SEPIA2,
        color: Colors.WHITE,
        height: "100%",
      };
    } else if (color === "DisabilitasTotal") {
      return {
        backgroundColor: Colors.GOLD2,
        color: Colors.DARK_GRAY5,
        height: "100%",
      };
    } else {
      return {
        backgroundColor: Colors.INDIGO3,
        color: Colors.WHITE,
        height: "100%",
      };
    }
  };

  return (
    <Card style={{ ...whatColor(secondaryColor) }}>
      <H1 className={loading ? Classes.SKELETON : Classes.TEXT_SMALL}>
        <span
          style={{
            color: whatColor(secondaryColor).color,
          }}
        >
          {/* {parseInt(total) || "Kosong"} */}
          { checkData(total) }
        </span>
      </H1>
      <div
        class="bp3-text-large"
        className={loading ? Classes.SKELETON : Classes.TEXT_SMALL}
      >
        {text}
      </div>  
    </Card>
  );
}
